/* eslint-disable no-script-url */
import React from 'react';
import PropTypes from 'prop-types';
import InViewObserver from 'components/InViewObserver';
import { UserPreferenceContext } from 'routes/home/layouts/India/context';
// import { TOI_HOMEPAGE_CARDCMS_URL, WEB_INDIA_HP_GA_CAT } from 'constants/index';
import Dropdown from 'components_v2/common/Dropdown/DropdownLoader';
import LinkList from 'components_v2/common/LinkList';
import makeRequest from 'utils/makeRequest';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import CardListV5 from 'components_v2/common/CardListV5';
import Card from 'components_v2/common/CardV2';
import Link from 'components/Link';
import LoaderSpinner from 'components_v2/common/LoaderSpinner';
// import NewscardComponent from 'components_v2/common/InitNewscardComponents';
import WithWeather from 'modules/WithWeather';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import _get from 'lodash.get';
import LinksList from 'components_v2/desktop/LinksList';
import s from './RowLayout.scss';
import Listingheader from '../../common/ListingheaderV2';
import AffiliateWidgetMain from '../../../../articleshow/components/AffiliateWidget/AffiliateWidgetMain';
import HeaderTab from '../HeaderTabV2';
import CityModal from '../CityModal/CityModalLoader';
import Infocus from '../Infocus';
import BudgetLinkout from '../../common/BudgetWidgetHP/BudgetLinkout';
import SponserAdSlot from '../../common/SponserAdSlot/index';
import ElectionBattle from '../../../../../components/ElectionV2/common/ElectionBattle/ElectionBattle';
import {
  cityNameMap,
  createSlug,
  randomNum,
} from '../../../../../utils/common';
import ErrorBoundary from '../../../../../components/ErrorBoundary/ErrorBoundary';

class RowLayout extends React.Component {
  constructor() {
    super();
    this.state = {
      shouldshowModal: false,
      cityForSection: null,
      navItems: null,
      cityUrl: null,
      starCandidatesData: [],
    };

    this.tabName = '';
  }

  componentDidMount() {
    if (!this.props.csr) {
      this.loadSection();
    }
    if (this.props.sectionData && this.props.sectionData.starCandidates) {
      this.refreshData();
    }
  }

  componentWillUnmount() {
    clearInterval(this.electionWidgetInterval);
  }

  refreshData = () => {
    this.electionWidgetInterval = setInterval(() => {
      this.loadLokSabhaCandidates();
    }, 30 * 1000);
  };

  loadLokSabhaCandidates = () => {
    const { sectionData } = this.props;
    if (
      sectionData &&
      sectionData.starCandidates &&
      sectionData.electionState
    ) {
      const electionStateSlug = createSlug(sectionData?.electionState);
      const dataUrl = `${sectionData.starCandidates}?t=${randomNum()}`;
      makeRequest.get(dataUrl, {}, 'skipfeedengine').then(result => {
        if (!(result && result.data)) {
          return;
        }
        const starCandidateData =
          result.data && Array.isArray(result.data) && result.data.length > 0
            ? result.data.filter(candidates => {
                if (typeof candidates?.star === 'string') {
                  return (
                    electionStateSlug === createSlug(candidates?.sn) &&
                    candidates.star
                      .toLowerCase()
                      .split(',')
                      .includes('tois')
                  );
                }
                return false;
              })
            : [];
        this.setState({
          starCandidatesData: starCandidateData,
        });
      });
    }
  };

  loadSection = () => {
    const { sectionData } = this.props;
    //for loading content
    if (sectionData && !Array.isArray(sectionData) && sectionData.dataUrl) {
      this.loadSectionData(sectionData.dataUrl);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const {
      geoCityData: { city: prevCity = '', state: prevGeoState = '' },
    } = prevProps;
    const { sectionData = {}, geoCityData: { city, state = '' } } = this.props;

    if (
      ((prevCity || city) &&
        prevCity !== city &&
        this.state.navItems &&
        this.state.navItems.length > 0) ||
      (!prevState.navItems &&
        city &&
        this.state.navItems &&
        this.state.navItems.length > 0)
    ) {
      this.loadDataForCity(city);
    }

    if (
      sectionData &&
      sectionData.id === 'elections' &&
      (((prevGeoState || state) &&
        prevGeoState !== state &&
        this.state.navItems &&
        this.state.navItems.length > 0) ||
        (!prevState.navItems &&
          state &&
          this.state.navItems &&
          this.state.navItems.length > 0))
    ) {
      const filteredHeaderTab = this.state.navItems.filter(
        tab => tab.name.toLowerCase() === state.toLowerCase(),
      );
      if (
        filteredHeaderTab.length > 0 &&
        this.tabName !== filteredHeaderTab[0].name
      ) {
        this.loadSectionData(
          filteredHeaderTab[0]?.dataUrl,
          true,
          filteredHeaderTab[0]?.path,
        );
        this.tabName = filteredHeaderTab[0].name;
      }
    }
  }

  loadNavigationData() {
    const { sectionData = {} } = this.props;
    if (sectionData.subSections && sectionData.subSections.dataUrl) {
      this.fetchNavigation(sectionData.subSections.dataUrl);
    }
  }

  fetchNavigation(dataUrl) {
    makeRequest.get(dataUrl, {}, 'skipfeedengine').then(data => {
      if (!(data && data.data)) {
        return;
      }
      const { items } = data.data;
      this.setState({
        headerItems: data.data.items,
        navItems: items,
      });
    });
  }

  // loadHeaderData = dataUrl => {
  //   if (!dataUrl) {
  //     return;
  //   }

  //   makeRequest.get(dataUrl, {}, 'skipfeedengine').then(data => {
  //     if (data && data.data && data.data.items && data.data.items.length > 0) {
  //       //console.log('data : ', data.data);
  //       this.setState({
  //         headerItems: data.data.items,
  //       });
  //     }
  //   });
  // };

  loadDataForCity = city => {
    if (typeof city !== 'string') {
      return;
    }
    // if (this.props.sectionData.id === 'citynews') {
    //   console.log('***** ROwlayout loadDataForCity', city);
    // }
    let cityName = cityNameMap[city] || city;
    const { navItems } = this.state;
    if (!Array.isArray(navItems)) {
      return;
    }
    const filteredCityByAlphabet = navItems.filter(node => {
      const alphabet =
        typeof node.name === 'string' ? node.name.toLowerCase() : '';
      return alphabet === cityName[0];
    });
    if (
      !(
        Array.isArray(filteredCityByAlphabet) &&
        filteredCityByAlphabet[0] &&
        Array.isArray(filteredCityByAlphabet[0].items)
      )
    ) {
      return;
    }
    const filteredCity = filteredCityByAlphabet[0].items.filter(node => {
      const nodeName =
        typeof node.name === 'string' ? node.name.toLowerCase() : '';
      cityName = cityNameMap[cityName] || cityName;
      return nodeName === cityName;
    });
    this.loadSectionData(
      filteredCity[0]?.dataUrl,
      true,
      filteredCity[0]?.path,
      cityName,
    );
  };

  loadSectionData = (dataUrl, ajaxCall, path, cityName = undefined) => {
    // if (this.props.sectionData.id === 'citynews') {
    //   console.log('***** ROwlayout loadSectionData', dataUrl);
    // }
    if (!dataUrl) {
      return;
    }
    this.setState({ loading: true, cityUrl: path });

    makeRequest.get(dataUrl, {}, 'skipfeedengine').then(data => {
      if (
        data &&
        data.data &&
        ((data.data.items && data.data.items.length > 0) ||
          data.data.length > 0)
      ) {
        //console.log('data : ', data.data);
        this.setState({
          items: data.data.items || data.data,
          ajaxCall: !!ajaxCall,
          loading: false,
        });
        this.props.loadAllAdsFromQueue('', window.location.pathname);
      } else {
        this.setState({ loading: false });
      }
      if (typeof cityName !== 'undefined') {
        this.tabName = cityName;
      }
    });
  };

  onTabsChange = params => {
    const { clickedItem: { name }, confirmMakingDefCity } = params;
    if (confirmMakingDefCity && name && this.context) {
      this.setState({
        cityForSection: null,
        cityUrl: params.clickedItem.path,
      });
      this.context.setLanguageVal(name, true);
    } else {
      this.setState({
        cityForSection: name,
      });
      if (params && params.clickedItem && params.clickedItem.dataUrl) {
        this.loadSectionData(
          params.clickedItem.dataUrl,
          true,
          params.clickedItem.path,
        );
      }

      if (params.clickedItem.name) {
        this.tabName = params.clickedItem.name;
      }
    }
  };

  toggleModal = () => {
    this.setState({
      shouldshowModal: !this.state.shouldshowModal,
    });

    if (!this.state.shouldshowModal) {
      const { sectionData = {} } = this.props;
      sendGaThroughProps({
        data: {
          // gaCategory: ,
          gaAction: `${sectionData.name}Section_CityChange`,
          gaLabel: 'CityChange_Click',
        },
      });
    }
  };

  renderHeader = () => {
    const {
      shouldshowModal,
      headerItems,
      cityForSection,
      cityUrl,
    } = this.state;
    const {
      sectionData = {},
      geoCityData,
      geoCityData: { city },
      cardsInsertsLite = {},
    } = this.props;
    const sectionName = sectionData.name;
    const headerTabs = this.props.subSections || headerItems;
    const cityName = cityForSection || city;
    const cardInsertContainer =
      cardsInsertsLite &&
      cardsInsertsLite.inserts &&
      sectionData &&
      sectionData.rhsCardId &&
      cardsInsertsLite.inserts[sectionData.rhsCardId];

    if (headerTabs && headerTabs instanceof Array && !this.tabName) {
      let cardInsertsDefaultTab;
      if (cardInsertContainer && cardInsertContainer.default_filter) {
        cardInsertsDefaultTab = headerTabs.filter(
          tab =>
            tab.name.toLowerCase() ===
            cardInsertContainer.default_filter.toLowerCase(),
        );
      }
      if (cardInsertsDefaultTab && cardInsertsDefaultTab.length > 0) {
        this.loadSectionData(
          cardInsertsDefaultTab[0]?.dataUrl,
          true,
          cardInsertsDefaultTab[0]?.path,
        );
        this.tabName = cardInsertsDefaultTab[0].name;
      } else if (headerTabs[0] && headerTabs[0].name) {
        this.tabName = headerTabs[0].name;
      }
    }
    return (
      <>
        {sectionData.id &&
          sectionData.subSectionsLayout === 'city_dropdown' && (
            <Listingheader
              headingname={sectionName}
              subheading={sectionData.subHeading}
              headingLink={sectionData.link || sectionData.path}
              newga={`click-${sectionName &&
                sectionName.replace(/ /g, '')}#${sectionData.link ||
                sectionData.path}`}
              overrideClass={sectionData.id === 'citizenreporter' ? 'mic' : ''}
              cityDropdown
              target={sectionData.target}
              isPrime={this.props.isPrime}
              ga4Type={sectionData?.ga4Type}
              ga4Category={sectionData?.ga4Category}
            >
              <>
                {shouldshowModal &&
                  sectionData.subSections &&
                  sectionData.subSections.dataUrl && (
                    <CityModal
                      dataUrl={sectionData.subSections.dataUrl}
                      onChangeCallback={this.onTabsChange}
                      // newga={`${
                      //   sectionData.name
                      // }Section_Actions_CityChange#CityChange_`}
                      gaData={{
                        gaAction: `${sectionData.name}Section_CityChange`,
                        partialGaLabel: 'CityChange_',
                      }}
                      geoCityData={geoCityData}
                      toggleModal={this.toggleModal}
                    />
                  )}
                <div className={s.cityDropdown}>
                  <div className={s.currentcity}>
                    {sectionData.id === 'citynews' ? (
                      <Link to={cityUrl || 'javascript: void(0)'}>
                        {cityNameMap[cityName] || cityName}
                      </Link>
                    ) : (
                      <React.Fragment>
                        {cityNameMap[cityName] || cityName}
                      </React.Fragment>
                    )}
                  </div>
                  {sectionData.id === 'citynews' && (
                    <WithWeather
                      lazyload
                      isWapView={false}
                      isWeatherInC
                      colorTheme="snowwhite"
                      hideCityName
                      forceCity={cityForSection || city}
                      addExtraClass={`${s.textcolor}`}
                    />
                  )}
                  <div className={s.changecity} onClick={this.toggleModal}>
                    Change City
                  </div>
                </div>
              </>
            </Listingheader>
          )}
        {sectionName && sectionData.subSectionsLayout !== 'city_dropdown' ? (
          <>
            <Listingheader
              headingname={sectionName}
              headingLink={sectionData.link || sectionData.path}
              subheading={sectionData.subHeading}
              overrideClass={sectionData.id === 'citizenreporter' ? 'mic' : ''}
              newga={`click-${sectionName.replace(
                / /g,
                '',
              )}#${sectionData.link || sectionData.path}`}
              target={sectionData.target}
              data={sectionData}
              isPrime={this.props.isPrime}
              ga4Type={sectionData?.ga4Type}
              ga4Category={sectionData?.ga4Category}
            >
              {headerTabs && headerTabs instanceof Array ? (
                <HeaderTab
                  subSections={headerTabs}
                  onChangeCallback={this.onTabsChange}
                  loading={this.state.loading}
                  active={
                    sectionData &&
                    sectionData.id === 'elections' &&
                    this.tabName
                  }
                  newga={`${sectionData.name}Section_TabChange#Click_`}
                  ga4Type={sectionData?.ga4Type}
                  ga4Category={sectionData?.ga4Category}
                />
              ) : (
                <React.Fragment>
                  {!sectionData.poweredByHtml && (
                    <Dropdown
                      data={
                        sectionData.navigation &&
                        sectionData.navigation.sections
                      }
                    />
                  )}
                  {sectionData.poweredByHtml && (
                    <div
                      className={s.poweredby}
                      dangerouslySetInnerHTML={{
                        __html: sectionData.poweredByHtml,
                      }}
                    />
                  )}
                </React.Fragment>
              )}
            </Listingheader>
            <div className="row noMr">
              <div className="col_l_8 col_m_12 noP">
                <SponserAdSlot
                  data={sectionData}
                  isPrime={this.props.isPrime}
                />
              </div>
            </div>
          </>
        ) : null}
      </>
    );
  };

  static renderInfocus(
    data,
    secname,
    cardKeywordsFilter = undefined,
    keywordsGa,
  ) {
    if (cardKeywordsFilter && data.dataUrl) {
      return (
        <Infocus
          title={data.title}
          secname={secname}
          dataUrl={data.dataUrl}
          type={data.type}
          cardKeywordsFilter={cardKeywordsFilter}
          csr
        />
      );
    }
    return data.type === 'slider' ? (
      <LinksList
        sectionData={data}
        cssSelector="opaquelist"
        gaCategory={keywordsGa && keywordsGa.gaCategory}
        gaAction={
          keywordsGa && keywordsGa.gaAction && `${keywordsGa.gaAction}Infocus`
        }
      />
    ) : (
      <Infocus
        title={data.title}
        data={data.items}
        secname={secname}
        type={data.type}
      />
    );
  }

  static renderVideoTiles(sectionData, listItems) {
    const data = listItems
      .reduce((acc, node) => acc.concat(node.items || []), [])
      .slice(0, 8);
    return (
      <CardListV5
        data={data}
        nonFeaturedDisplay={{
          itemClass: 'linktype2',
          itemWrapperClass: 'col_l_3 col_m_3',
          textItemWrapperClass: 'bdr_right no_bdr_last',
          listWrapperClass: 'row',
        }}
        newga={`click-${sectionData.name}#`}
        htmlKeys={data.htmlKeys}
        key={`${sectionData.id}_${data.tn}`}
      />
    );
  }

  componentRender = () => {
    const {
      sectionData = {},
      cardClass = '',
      cardsInsertsLite = {},
      hideSeperator,
    } = this.props;
    const { cityForSection } = this.state;
    const sectionName = sectionData.name || sectionData.secName;
    const cardInsertContainer =
      cardsInsertsLite &&
      cardsInsertsLite.inserts &&
      sectionData &&
      sectionData.rhsCardId &&
      cardsInsertsLite.inserts[sectionData.rhsCardId];

    let listItems;
    const scrollGAAttr = {
      ...(sectionData.onScrollGA &&
        sectionData.id && { 'data-scrollga': sectionData.id }),
    };

    if (this.state.ajaxCall) {
      listItems = this.state.items;
    } else {
      listItems = sectionData.items || this.state.items;
    }
    const shouldRenderVideoTiles =
      typeof cityForSection === 'string' &&
      cityForSection.toUpperCase() === 'VIDEOS';
    return (
      <div
        className={`${s.section_wrapper} ${
          sectionData.id === 'sports' ? s[sectionData.id] : ''
        } 
        ${
          sectionData.className && sectionData.className !== ''
            ? sectionData.className
            : ''
        }`}
        {...scrollGAAttr}
        id={
          sectionData &&
          (sectionData.id === 'financial-calculator' || sectionData.jumplinkId)
            ? sectionData.jumplinkId || sectionData.id
            : ''
        }
      >
        {sectionData.border &&
          sectionData.border === 'top' &&
          !hideSeperator && <InterSectionBorder border={sectionData.border} />}
        {sectionData.subSections &&
          sectionData.subSections.dataUrl &&
          this.state.loading && <LoaderSpinner />}

        {this.renderHeader()}
        <div className={`${'row'}`}>
          <div className={`${'col_l_8 col_m_12 padR32'}  ${s.rhs_border}`}>
            {shouldRenderVideoTiles
              ? RowLayout.renderVideoTiles(sectionData, listItems)
              : null}
            {!shouldRenderVideoTiles &&
              sectionData &&
              listItems instanceof Array &&
              listItems.map((itemObj = {}) => {
                const item = itemObj;
                const spaceRemoverGA = val => val && val.replace(/ /g, '');
                switch (item.tn) {
                  case 'lead_plus_4_list': {
                    if (!item.items || item.items.length < 1) {
                      return null;
                    }
                    return (
                      <div className={`${'row'}`}>
                        <div className="col_l_6 col_m_6">
                          <Card
                            data={item.items[0]}
                            itemClass="col_l_12 col_m_12"
                            showLiveBtn
                            isLeadTypeTwo
                            nonFeaturedListWrapperClass="col_l_12 col_m_12"
                            newga={`click-${spaceRemoverGA(sectionName)}${
                              this.tabName ? `${this.tabName}` : ''
                            }-lead#${item.items[0].wu || ''}`}
                            htmlKeys={item.htmlKeys}
                            key={`${sectionData.id}_${item.tn}`}
                            ga4Type={sectionData?.ga4Type}
                            ga4Category={sectionData?.ga4Category}
                            gaIndex={item.items[0].gaindex}
                          />
                        </div>
                        <div className={`${s.rightNews} col_l_6 col_m_6`}>
                          <LinkList
                            data={item.items.slice(1)}
                            className="linktype1"
                            newga={`click-${spaceRemoverGA(sectionName)}-${
                              this.tabName ? `${this.tabName}-` : ''
                            }$index#`}
                            ga4Type={sectionData?.ga4Type}
                            ga4Category={sectionData?.ga4Category}
                          />
                        </div>
                      </div>
                    );
                  }
                  case 'column_2_list': {
                    return (
                      <CardListV5
                        data={item.items}
                        nonFeaturedDisplay={{
                          hideImage: item.hasImage !== '1',
                          itemClass: 'linktype2',
                          itemWrapperClass: 'col_l_3 col_m_3',
                          textItemWrapperClass: 'bdr_right no_bdr_last',
                          listWrapperClass: 'row',
                          cardClass,
                        }}
                        newga={`click-${sectionName}${
                          this.tabName ? `-${this.tabName}` : ''
                        }`}
                        htmlKeys={item.htmlKeys}
                        key={`${sectionData.id}_${item.tn}`}
                        showSecName={item.hasSectionName === 1}
                        ga4Type={sectionData?.ga4Type}
                        ga4Category={sectionData?.ga4Category}
                      />
                    );
                  }

                  case 'affiliate_widget':
                    return (
                      <AffiliateWidgetMain
                        isWapView={this.props.isWapView}
                        url={item.dataUrl} //"/feed_affiliate_sponsor_api_react/msid-71422513,title-Top%20Deals,limit-10,tag-toi_hp_bestseller_web_widget-20,feedtype-json.cms"
                        slidesToShow={3.5}
                        slidesToScroll={3}
                        noDataCallBack={() => {
                          this.noDataCallBack('affiliate_widget');
                        }}
                        //updateSlidesForGutterAds
                        key={`${sectionData.id}_${item.tn}`}
                      />
                    );

                  default: {
                    return null;
                  }
                }
              })}
          </div>

          <div className={`${'col_l_4 hide_m padL32'}`}>
            {cardInsertContainer && sectionData.rhsCardId ? null : (
              // <NewscardComponent
              //   isWapView={this.props.isWapView}
              //   cardsInsertsLite={cardInsertContainer}
              //   slot={sectionData.rhsCardId}
              //   apiUrl={TOI_HOMEPAGE_CARDCMS_URL}
              //   tokens={
              //     cardsInsertsLite.whoami && cardsInsertsLite.whoami.tokens
              //   }
              //   campaignName={
              //     cardInsertContainer && cardInsertContainer.campaign_name
              //   }
              //   gaCat={WEB_INDIA_HP_GA_CAT}
              //   location={this.props.location}
              //   externalFilterTab={this.tabName}
              //   hideTabs
              // />
              <>
                {[
                  this.state.items
                    ? this.props.renderInsertsFn({
                        ...sectionData,
                        items: this.state.items,
                      })
                    : this.props.children,
                ]}
              </>
            )}
          </div>
        </div>
        {this.state.starCandidatesData &&
          Array.isArray(this.state.starCandidatesData) &&
          this.state.starCandidatesData.length > 0 && (
            <>
              <InterSectionBorder />
              <div className={s.electionBattleWrap}>
                <ErrorBoundary>
                  <ElectionBattle
                    infiniteScroll={false}
                    slidesToShow={6}
                    slidesToScroll={6}
                    candidateLinking
                    starCandidateData={this.state.starCandidatesData}
                    blackArrow
                  />
                </ErrorBoundary>
              </div>
            </>
          )}
        {sectionData.slider ? (
          <div className={s.BudgetLink}>
            <BudgetLinkout data={sectionData.slider} />
          </div>
        ) : (
          ''
        )}

        {sectionData.keywords
          ? RowLayout.renderInfocus(
              sectionData.keywords,
              `${_get(sectionData, 'name', '')}Infocus`,
              false,
              {
                gaCategory: this.props.keywordGaCategory,
                gaAction: this.props.keywordGaAction,
              },
            )
          : ''}
        {sectionData.cardkeywords
          ? RowLayout.renderInfocus(
              sectionData.cardkeywords,
              `${_get(sectionData, 'name', '')}Infocus`,
              this.tabName && typeof this.tabName === 'string' && this.tabName,
            )
          : null}
        {sectionData.border &&
          sectionData.border === 'bottom' && (
            <InterSectionBorder border={sectionData.border} />
          )}
      </div>
    );
  };

  render() {
    const { csr } = this.props;
    return (
      <>
        {csr ? (
          <InViewObserver
            inViewCallback={() => {
              this.loadSection();
              this.loadNavigationData();
              this.loadLokSabhaCandidates();
            }}
            viewMargin="400px 0px 400px 0px"
          >
            {this.componentRender()}
          </InViewObserver>
        ) : (
          this.componentRender()
        )}
      </>
    );
  }
}
RowLayout.propTypes = {
  sectionData: PropTypes.shape({
    id: PropTypes.string,
    subSections: PropTypes.shape({
      dataUrl: PropTypes.string,
    }),
    dataUrl: PropTypes.string,
    starCandidates: PropTypes.string,
    electionState: PropTypes.string,
  }).isRequired,
  subSections: PropTypes.shape({}),
  isWapView: PropTypes.bool,
  children: PropTypes.element,
  loadAjaxSectionData: PropTypes.func.isRequired,
  renderInsertsFn: PropTypes.func,
  loadAllAdsFromQueue: PropTypes.func,
  geoCityData: PropTypes.shape({
    city: PropTypes.string,
    state: PropTypes.string,
  }),
  csr: PropTypes.bool,
  cardClass: PropTypes.bool,
  location: PropTypes.string,
  keywordGaCategory: PropTypes.string,
  keywordGaAction: PropTypes.string,
  hideSeperator: PropTypes.bool,
};

RowLayout.defaultProps = {
  isWapView: false,
  children: undefined,
  renderInsertsFn: () => {},
  loadAllAdsFromQueue: () => {},
  geoCityData: {},
  subSections: null,
  csr: false,
  cardClass: false,
  location: null,
  keywordGaCategory: undefined,
  keywordGaAction: undefined,
  hideSeperator: false,
};

RowLayout.contextType = UserPreferenceContext;

export default RowLayout;
